export const buildEnableOneProduct = (state, action) => {
  return state.map((item) => {
    if (item.id === action.id) {
      return { ...item, isDisabled: false };
    }

    return item;
  });
};

export const buildDisableOneProduct = (state, action) => {
  return state.map((item) => {
    if (item.id === action.id) {
      return { ...item, isDisabled: true };
    }

    return item;
  });
};
